import React from 'react';
import { Badge, Button } from '../../../core/ui';
import { useTranslation } from '../../../core/context/TranslationContext';
import { removeMember } from '../api/family';
import { useFamily } from '../context/FamilyContext';
import styles from './MemberRow.module.css';

export default function MemberRow({ member, callerIsOwner, callerId }) {
  const { t } = useTranslation();
  const { refresh } = useFamily();

  const handleRemove = async () => {
    if (!window.confirm(t('family.remove.confirm'))) return;
    try {
      await removeMember(member.userId);
      await refresh();
    } catch (err) {
      alert(err.response?.data?.message || t('error'));
    }
  };

  return (
    <tr>
      <td>{member.username}</td>
      <td>
        <Badge variant={member.role === 'OWNER' ? 'warning' : 'neutral'}>
          {member.role === 'OWNER' ? t('family.members.role.owner') : t('family.members.role.member')}
        </Badge>
      </td>
      <td>
        <Badge variant={member.shareReceipts ? 'success' : 'neutral'} className={styles.badgeSpacing}>
          {t('family.share.receipts')}
        </Badge>
        <Badge variant={member.shareBudget ? 'success' : 'neutral'}>
          {t('family.share.budget')}
        </Badge>
      </td>
      <td>
        {callerIsOwner && member.userId !== callerId && (
          <Button size="sm" variant="dangerGhost" onClick={handleRemove}>
            {t('family.remove')}
          </Button>
        )}
      </td>
    </tr>
  );
}
